import React, { useEffect, useState } from 'react';

const MiniGardenImage = ({ gardenMatrix }) => {
    const [normalizedMatrix, setNormalizedMatrix] = useState([]);

    function normalizeArray(dataString) {
        let array = dataString.trim().split("\n").map(row => row.split(",").map(Number));
        array = array.filter(row => row.some(value => value !== 0));
        let transposed = array[0].map((_, colIndex) => array.map(row => row[colIndex]));
        transposed = transposed.filter(col => col.some(value => value !== 0));
        return transposed[0].map((_, rowIndex) => transposed.map(col => col[rowIndex]));
    }

    useEffect(() => {
        setNormalizedMatrix(normalizeArray(gardenMatrix));
    }, [gardenMatrix]);

    return (
        <div className="mini-garden-image">
            <div
                className="mini-garden-image-matrix"
                style={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${normalizedMatrix[0]?.length || 0}, 5px)`,
                    gap: "0px"
                }}
            >
                {normalizedMatrix.map((row, rowIndex) =>
                    row.map((value, colIndex) => {
                        const isFilled = value === 1;

                        // Neighbor check helpers (guarding array bounds)
                        const top = normalizedMatrix[rowIndex - 1]?.[colIndex] === 1;
                        const bottom = normalizedMatrix[rowIndex + 1]?.[colIndex] === 1;
                        const left = normalizedMatrix[rowIndex]?.[colIndex - 1] === 1;
                        const right = normalizedMatrix[rowIndex]?.[colIndex + 1] === 1;

                        const topLeft = normalizedMatrix[rowIndex - 1]?.[colIndex - 1] === 1;
                        const topRight = normalizedMatrix[rowIndex - 1]?.[colIndex + 1] === 1;
                        const bottomLeft = normalizedMatrix[rowIndex + 1]?.[colIndex - 1] === 1;
                        const bottomRight = normalizedMatrix[rowIndex + 1]?.[colIndex + 1] === 1;

                        let borderRadius = "";

                        if (!top && !left && !topLeft) borderRadius += "3px 0 0 0,";
                        if (!top && !right && !topRight) borderRadius += "0 3px 0 0,";
                        if (!bottom && !left && !bottomLeft) borderRadius += "0 0 0 3px,";
                        if (!bottom && !right && !bottomRight) borderRadius += "0 0 3px 0,";

                        // Convert borderRadius to standard CSS syntax
                        const radiusArray = borderRadius
                            .split(",")
                            .filter(Boolean)
                            .map((r, i) => {
                                switch (i) {
                                    case 0: return r;
                                    case 1: return r;
                                    case 2: return r;
                                    case 3: return r;
                                    default: return "0";
                                }
                            });

                        return (
                            <div
                                key={`${rowIndex}-${colIndex}`}
                                style={{
                                    width: "5px",
                                    height: "5px",
                                    backgroundColor: isFilled ? "#6d4c41" : "transparent",
                                    borderRadius: radiusArray.join(" "),
                                }}
                            ></div>
                        );
                    })
                )}

            </div>
        </div>
    );
};

export default MiniGardenImage;
